export default __webpack_public_path__ + "img/square_2.687f1aed7db4e039293b51292a2fe1fb.jpg";